// extracted by mini-css-extract-plugin
export default {"isDragging":"bwegG","child":"RaiyN"};